var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},_vm._l((_vm.sortedDocuments),function(doc){return _c('document-element',{key:doc.id,class:_vm.rowClass,attrs:{"doc":doc,"show-drag":_vm.showDrag},on:{"deleteImage":function($event){_vm.$emit('deleteImage', $event)},"moveOutOfFolder":function($event){_vm.$emit('moveOutOfFolder', $event)}}})}))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a93cbe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/DocumentGallary.vue
// module id = tlwW
// module chunks = 0